import axios from "@/lib/axios";
import { User } from "@/modules/users/interfaces/user";
import { useQuery } from "@tanstack/vue-query";
import { ref, watch } from "vue";

interface Props {
  immediate?: boolean;
  params?: Params;
}

interface Params {
  q?: string;
  internalOnly?: number;
}

const getInternalSearchUser = async (params: Params): Promise<User[]> => {
  const { data } = await axios.get<User[]>("api/internal/users/search", {
    params: {
      q: params.q ? params.q : undefined,
      internalOnly: params.internalOnly,
    },
  });

  return data;
};

const useInternalSearchUser = (props: Props) => {
  const { immediate = true, params } = props;

  const query = ref("");

  const { data, isLoading, refetch } = useQuery(
    ["internal-search-user", query],
    () =>
      getInternalSearchUser({
        q: query.value,
        internalOnly: params?.internalOnly,
      }),
    {
      enabled: immediate,
    },
  );

  const setQuery = (value: string) => {
    query.value = value;
  };

  watch(query, () => {
    refetch();
  });

  return {
    data,
    isLoading,
    query,
    refetch,
    setQuery,
  };
};

export default useInternalSearchUser;
